// @ts-nocheck
import React, { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	TextField,
	Alert,
	Box,
} from '@mui/material';

import { deleteBillingAccount } from '../../Services/billingAccount';

interface Props {
	billingAccount: { id: string; name: string };
	open: boolean;
	onClose: () => void;
	onDeleted: () => void;
}

export const BillingAccountDeleteModal: React.FC<Props> = ({
	billingAccount,
	open,
	onClose,
	onDeleted,
}) => {
	const [confirmName, setConfirmName] = useState('');
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const matches = confirmName.trim() === billingAccount.name;

	const handleClose = () => {
		if (submitting) return;
		setConfirmName('');
		setError(null);
		onClose();
	};

	const handleConfirm = async () => {
		if (!matches) return;
		setSubmitting(true);
		setError(null);
		try {
			await deleteBillingAccount(billingAccount.id);
			onDeleted();
		} catch (e: any) {
			setError(e?.message || 'Failed to delete billing account');
			setSubmitting(false);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle sx={{ color: 'error.main' }}>
				⚠️ Delete Billing Account
			</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>
					This action is <strong>irreversible</strong>. It will cascade delete:
					projects, connector accounts, managed BigQuery datasets, subscriptions
					and entitlements. The <strong>Stripe customer is deleted too</strong>,
					after its live subscriptions are cancelled — past invoices stay
					readable in Stripe, but nothing links them to this account anymore.
				</DialogContentText>

				<DialogContentText sx={{ mb: 1 }}>
					To confirm, type the billing account name exactly:{' '}
					<strong>{billingAccount.name}</strong>
				</DialogContentText>

				<TextField
					fullWidth
					autoFocus
					value={confirmName}
					onChange={(e) => setConfirmName(e.target.value)}
					placeholder={billingAccount.name}
					disabled={submitting}
					error={confirmName.length > 0 && !matches}
					helperText={
						confirmName.length > 0 && !matches
							? "Name doesn't match"
							: ' '
					}
				/>

				{error && (
					<Box sx={{ mt: 2 }}>
						<Alert severity="error">{error}</Alert>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} disabled={submitting}>
					Cancel
				</Button>
				<Button
					onClick={handleConfirm}
					disabled={!matches || submitting}
					color="error"
					variant="contained"
				>
					{submitting ? 'Deleting...' : 'Delete billing account'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
